var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"singleActions":_vm.singleActions,"exportDataOptions":_vm.exportDataOptions}}),_c('a',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"exportButton",attrs:{"download":"","id":_vm.downloadId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }